var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionplanMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1176,
    height: 1176,
    viewBox: "0 0 1176 1176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3393_819)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1176,
    height: 1176,
    rx: 336,
    fill: "#2340A9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 882,
    height: 210,
    fill: "url(#paint0_linear_3393_819)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 966,
    width: 882,
    height: 210,
    fill: "url(#paint1_linear_3393_819)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -306.633,
    y: -130.02,
    width: 2100,
    height: 924,
    transform: "rotate(15 -306.633 -130.02)",
    fill: "url(#paint2_linear_3393_819)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.039,
    y: 483.003,
    width: 546,
    height: 63,
    rx: 31.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.031,
    y: 819.002,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.02,
    y: 672.002,
    width: 546,
    height: 63,
    rx: 31.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 798.02,
    y: 336.003,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3393_819",
    x1: -0.00000279632,
    y1: 105.337,
    x2: 1152.11,
    y2: -57.6625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F61DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2340A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3393_819",
    x1: 294,
    y1: 1071.34,
    x2: 1446.11,
    y2: 908.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C4BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2340A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3393_819",
    x1: -227.553,
    y1: 62.007,
    x2: 370.393,
    y2: 1144.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#617DE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3552BA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3393_819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1176,
    height: 1176,
    rx: 336,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionplanMark);
export default __webpack_public_path__ + "static/media/actionplan-mark.ce9aaa234b1436549f5765df48c13dbb.svg";
export { ForwardRef as ReactComponent };